import {HTMLProps} from 'react';
import clsx from 'clsx';

type Props = HTMLProps<HTMLHeadingElement> & {
  ['data-testid']?: string;
};

const SectionTitle = ({className, children, ...props}: Props) => {
  return (
    <h2 className={clsx('my-4 text-2xl font-semibold tracking-tight text-violet', className)} {...props}>
      {children}
    </h2>
  );
};

export default SectionTitle;
